function formatCPF(numero) {
    const cpf = numero.toString().replace(/\D/g, '');

    if (cpf.length !== 11) {
        return numero;
    }

    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
}


function formatPhone(numero) {
    const phone = numero.toString().replace(/\D/g, '');

    if (phone.length <= 2) {
        return phone;
    } else if (phone.length <= 7) {
        return phone.replace(/(\d{2})(\d{0,5})/, '($1) $2');
    } else {
        return phone.replace(/(\d{2})(\d{4,5})(\d{0,4})/, '($1) $2-$3');
    }
}

function formatCEP(numero) {
    const cep = numero.toString().replace(/\D/g, '');

    if (cep.length !== 8) {
        return numero;
    }

    return cep.replace(/(\d{5})(\d{3})/, '$1-$2');
}


function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export { formatCPF, formatPhone, formatCEP, capitalize };